<template>
      <OrderCard :orderid="this.$route.params.id" />
</template>

<script>
// @ is an alias to /src
import OrderCard from '@/components/OrderCard.vue'

export default {
  name: 'OrdersView',
  components: {
    OrderCard
  }
}
</script>
